/**
 * IDリマインダフォーム 編集画面 script
 *
 * @copyright       Copyright (C) iTEC Hankyu Hanshin Co., Ltd.
 * @package
 * @since           2021/08/02
 * @version         1.00
 */

jQuery(function () {
    /* //読み込み時の処理 */
    SelBirthdayTelChange();

    /* 生年月日/電話番号変更時の処理 */
    $("[name='selBirthdayTel']").on('change',function(){
	    SelBirthdayTelChange();
	});
});

/* 活性、非活性の切り替え */
function SelBirthdayTelChange(){

    radio1 = $('#IdReminderSelBirthdayTel1');
    radio2 = $('#IdReminderSelBirthdayTel2');
    if(radio1.is(':checked')) {
         $("#IdReminderTel1").prop("disabled",true);
         $("#IdReminderTel2").prop("disabled",true);
         $("#IdReminderTel3").prop("disabled",true);
         $("#birthday").prop("disabled",false);
    } else if(radio2.is(':checked')) {
         $("#IdReminderTel1").prop("disabled",false);
         $("#IdReminderTel2").prop("disabled",false);
         $("#IdReminderTel3").prop("disabled",false);
         $("#birthday").prop("disabled",true);
    } else {
         $("#IdReminderTel1").prop("disabled",true);
         $("#IdReminderTel2").prop("disabled",true);
         $("#IdReminderTel3").prop("disabled",true);
         $("#birthday").prop("disabled",true);
    }
}
